module.exports = __webpack_public_path__ + "img/hover-imgs-item-1.d86601c9.png";